import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { GraphSearchView } from '#/components/graph-search/graph-search-view'
import { useCan } from '#/user/me'

export const Route = createFileRoute(
  '/_authed/accounts/$accountId/graph-search',
)({
  component: GraphSearchPage,
})

function GraphSearchPage() {
  const { t } = useTranslation()
  const { accountId } = Route.useParams()
  const canViewInternal = useCan('annwn:internal:read')

  if (!canViewInternal) {
    return (
      <p className="p-8 text-sm text-muted-foreground">
        {t('internal.noAccess')}
      </p>
    )
  }

  return <GraphSearchView accountId={accountId} />
}
